<script setup lang="ts">
import GestionSites from '@/components/admin/GestionSites.vue'



const theme = useTheme()
const activeTab = ref('sites')
</script>

<template>
  <v-card class="mx-4 my-4 page-card" rounded="xl" style="height: 85vh; display: flex; flex-direction: column;">

    <!-- ── Page header ─────────────────────────────────────────────── -->
    <div class="page-header px-5 pt-5 pb-3">
      <div class="d-flex align-center" style="gap: 12px;">
        <v-avatar color="primary" variant="tonal" size="44" rounded="lg">
          <v-icon icon="M3,17V19H9V17H3M3,5V7H13V5H3M13,21V19H21V17H13V15H11V21H13M7,9V11H3V13H7V15H9V9H7M21,13V11H11V13H21M15,9H17V7H21V5H17V3H15V9Z" size="26"/>
        </v-avatar>
        <div>
          <div class="text-h6 font-weight-bold" style="line-height: 1.2;">Paramètres globaux</div>
          <div class="text-caption text-medium-emphasis">Sites (réservé aux administrateurs)</div>
        </div>
      </div>
    </div>

    <v-divider/>

    <!-- ── Tabs ─────────────────────────────────────────────────────── -->
    <v-tabs v-model="activeTab" density="compact" class="px-2 pt-1" color="primary">
      <v-tab value="sites" prepend-icon="M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z">Sites</v-tab>
    </v-tabs>

    <v-divider/>

    <!-- ── Content ──────────────────────────────────────────────────── -->
    <div style="flex: 1 1 auto; overflow: auto;">
      <v-window v-model="activeTab">
        <v-window-item value="sites">
          <GestionSites/>
        </v-window-item>
      </v-window>
    </div>

  </v-card>
</template>

<style scoped>
/* ── Page header ─────────────────────────── */
.page-header {
  background: v-bind('theme.global.name.value === "dark" ? "rgba(var(--v-theme-surface-variant), 0.25)" : "rgba(var(--v-theme-primary), 0.04)"');
}
</style>
